interface SearchStatsProps {
  totalResults: number;
}

export const SearchStats = ({ totalResults }: SearchStatsProps) => {
  return (
    <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
      Found {totalResults.toLocaleString()} {totalResults === 1 ? 'result' : 'results'}
    </div>
  );
};